import { render } from "./ResourceShareGroupInput.vue?vue&type=template&id=386f9fec"
import script from "./ResourceShareGroupInput.vue?vue&type=script&lang=ts"
export * from "./ResourceShareGroupInput.vue?vue&type=script&lang=ts"
script.render = render

export default script